



import IMapProperty from './private/IMapProperty';


const MAPPINGS: Array<IMapProperty> = [
    {
    'localName' : 'id',
    'externalName' : 'id',
    'defaultValue' : 0,
},
{
    'localName' : 'name',
    'externalName' : 'name',
    'defaultValue' : '',
},
{
    'localName' : 'logoFileName',
    'externalName' : 'logoFileName',
    'defaultValue' : '',
},
{
    'localName' : 'removeLogo',
    'externalName' : 'removeLogo',
    'defaultValue' : false,
},
{
    'localName' : 'logoMediumId',
    'externalName' : 'logoMediumId',
    'defaultValue' : '',
},
{
    'localName' : 'alarmEnabled',
    'externalName' : 'alarmEnabled',
    'defaultValue' : false,
},
{
    'localName' : 'alarmPin',
    'externalName' : 'alarmPin',
    'defaultValue' : '',
},
{
    'localName' : 'adminPin',
    'externalName' : 'adminPin',
    'defaultValue' : '',
},
{
    'localName' : 'languageSelectionMenu',
    'externalName' : 'languageSelectionMenu',
    'defaultValue' : 0,
},
{
    'localName' : 'tourSelectionMenu',
    'externalName' : 'tourSelectionMenu',
    'defaultValue' : 0,
},
{
    'localName' : 'clientId',
    'externalName' : 'clientId',
    'defaultValue' : 0,
},
{
    'localName' : 'screenOrientationId',
    'externalName' : 'screenOrientationId',
    'defaultValue' : 0,
},
{
    'localName' : 'majorVersion',
    'externalName' : 'majorVersion',
    'defaultValue' : 0,
},
{
    'localName' : 'minorVersion',
    'externalName' : 'minorVersion',
    'defaultValue' : 0,
},
{
    'localName' : 'toursCount',
    'externalName' : 'toursCount',
    'defaultValue' : 0,
},
{
    'localName' : 'deviceAccountsCount',
    'externalName' : 'deviceAccountsCount',
    'defaultValue' : 0,
},
{
    'localName' : 'languageSelectionStyleId',
    'externalName' : 'languageSelectionStyleId',
    'defaultValue' : 0,
},
{
    'localName' : 'tourSelectionStyleId',
    'externalName' : 'tourSelectionStyleId',
    'defaultValue' : 0,
},
];

export default MAPPINGS;

